<template>
  <div class="container search-bar">
    <div class="video-filter-container">
      <h3>אשמח למצוא שיעור</h3>
      <transition name="slide-down">
        <div class="columns is-multiline basic-search" v-if="!textSearch">
          <div class="column is-3-desktop">
            <dropdown-multi
              :item="metaStyleOptions"
              :show="buttons.metaStyles"
              v-on:show-options="openOptions('metaStyles')"
              v-on:close-options="closeOptions()"
              v-on:option-selected="updateSelection($event, 'metaStyles')"
            ></dropdown-multi>
          </div>
          <div class="column is-3-desktop">
            <dropdown-multi
              :item="styleOptions"
              :show="buttons.styles"
              v-on:show-options="openOptions('styles')"
              v-on:close-options="closeOptions()"
              v-on:option-selected="updateSelection($event, 'styles')"
            ></dropdown-multi>
          </div>
          <div class="column is-3-desktop">
            <dropdown-multi
              :item="levelOptions"
              :show="buttons.levels"
              :cols="1"
              v-on:show-options="openOptions('levels')"
              v-on:close-options="closeOptions()"
              v-on:option-selected="updateSelection($event, 'levels')"
            ></dropdown-multi>
          </div>
          <div class="column is-3-desktop">
            <dropdown-multi
              :item="{
                title: 'אורך',
                includes: $store.state.initialData.durations,
                info: 'testing',
                selected: selected.durations,
              }"
              :show="buttons.durations"
              v-on:show-options="openOptions('durations')"
              v-on:close-options="closeOptions()"
              v-on:option-selected="updateSelection($event, 'durations')"
            ></dropdown-multi>
          </div>
        </div>
      </transition>

      <transition name="slide-down">
        <div class="columns is-multiline" v-if="!showAdvanced">
          <div class="column is-9-desktop">
            <div>
              <a
                href="#"
                class="advanced-search-control"
                @click.prevent="
                  $emit('show-modal');
                  $store.dispatch(`setSearchParams`, selected);
                "
                ><i class="mdi mdi-plus"></i> חיפוש מתקדם</a
              >
              <a
                href="#"
                class="advanced-search-control"
                @click.prevent="$emit('show-textsearch')"
                ><i class="mdi mdi-magnify" v-if="!textSearch"></i
                ><i class="mdi mdi-close" v-if="textSearch"></i> חיפוש חופשי</a
              >
            </div>
          </div>
          <div class="column has-text-left is-3-desktop" v-if="!textSearch">
            <a href="#" class="yoga-btn" @click.prevent="getResults">חיפוש</a>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import DropdownMulti from "@/components/newSearch/searchDropDownMulti.vue";

export default {
  props: {
    full: Boolean,
  },
  data() {
    return {
      selected: {
        metaStyles: [],
        styles: [],
        levels: [],
        durations: [],
        tempo: [],
        teachers: [],
        focus: [],
        bodyPart: [],
        equipment: [],
      },
      showAdvanced: false,
      textSearch: false,
      searchTerm: "",
      buttons: {
        metaStyles: false,
        styles: false,
        levels: false,
        durations: false,
        tempo: false,
        teachers: false,
        focus: false,
        bodyPart: false,
        equipment: false,
      },
    };
  },
  components: {
    DropdownMulti,
  },
  computed: {
    metaStyleOptions() {
      const metaStyles = this.$store.state.initialData.styles.map(item => {
        let tags = [];
        this.$store.state.initialData.currents.forEach(c => {
          if (item.includes.includes(c.resource.id)) {
            tags.push(c.id);
          }
        });
        return { id: item.MIGX_id, label: item.label, includes: tags };
      });
      return {
        title: "סגנון",
        includes: metaStyles,
        selected: this.selected.metaStyles,
      };
    },
    styleOptions() {
      const metaStyles = this.$store.state.initialData.styles;
      let styles = this.$store.state.initialData.currents;
      if (this.selected.metaStyles.length > 0) {
        const selected = this.selected.metaStyles.map(item => {
          return item.id;
        });
        let included = [];
        metaStyles.forEach(meta => {
          if (selected.includes(meta.MIGX_id)) {
            if (included.length > 0) {
              included = [...included, ...meta.includes];
            } else {
              included = meta.includes;
            }
          }
        });
        styles = styles.filter(style => included.includes(style.resource.id));
      }
      return {
        title: "זרם",
        includes: styles,
        selected: this.selected.styles,
      };
    },
    levelOptions() {
      const levels = this.$store.state.initialData.levels.map(item => {
        return { label: item.label, id: item.value, value: item.value };
      });
      return {
        title: "רמה",
        includes: levels,
        info: "testing",
        selected: this.selected.levels,
      };
    },
  },
  methods: {
    showAdvancedSearch() {
      this.showAdvanced = true;
      this.textSearch = false;
    },
    showTextSearch() {
      this.showAdvanced = false;
      this.textSearch = true;
    },
    openOptions(name) {
      let keys = Object.keys(this.buttons);
      let obj = {};
      keys.forEach(key => {
        if (key === name) {
          obj[key] = true;
        } else {
          obj[key] = false;
        }
        this.buttons = obj;
      });
      this.buttons[name] = true;
    },
    closeOptions() {
      this.buttons = {
        metaStyles: false,
        styles: false,
        levels: false,
        durations: false,
        tempo: false,
        teachers: false,
        focus: false,
        bodyPart: false,
        equipment: false,
      };
    },
    checkClose(e) {
      if (
        e.target.classList[0] !== "dropdown-btn" &&
        e.target.classList[0] !== "dropdown-option" &&
        e.target.classList[0] !== "mdi"
      ) {
        this.closeOptions();
      }
    },
    updateSelection(payload, target) {
      this.selected[target] = payload;
      this.$store.dispatch(`setSearchParams`, this.selected);
    },
    getResults(e) {
      let obj = {
        term: this.searchTerm,
        metaStyles: this.flattenQuery(this.selected.metaStyles),
        styles: this.falttenStylesQuery(this.selected.styles),
        levels: this.flattenQuery(this.selected.levels),
        durations: this.flattenQuery(this.selected.durations),
        tempo: this.flattenQuery(this.selected.tempo),
        teachers: this.flattenQuery(this.selected.teachers),
        focus: this.flattenQuery(this.selected.focus),
        bodyPart: this.flattenQuery(this.selected.bodyPart),
        equipment: this.flattenQuery(this.selected.equipment),
      };

      this.$store.dispatch(`getVideoResults`, obj);
      this.$store.dispatch(`setSearchParams`, this.selected);
      this.$store.commit("setSearchTerm", this.searchTerm);
      e.currentTarget.blur();
      this.$router.push("results");
    },
    flattenQuery(arr) {
      const ids = arr.map(item => item.id);
      return ids.join(",");
    },
    falttenStylesQuery(arr) {
      const ids = arr.map(item => item.resource.id);
      return ids.join(",");
    },
  },
  mounted() {
    if (Object.keys(this.$store.state.sort.selected).length > 0) {
      this.selected = this.$store.state.sort.selected;
    }
    if (this.full) {
      this.showAdvanced = true;
    }
  },
  created() {
    window.addEventListener("click", this.checkClose);
  },
  destroyed() {
    window.removeEventListener("click", this.checkClose);
  },
};
</script>

<style lang="scss">
.container.search-bar {
  margin-bottom: 2em;
  background-color: #ffffff;
  padding: 1rem;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.25);
}

.video-filter-container {
  position: relative;
  z-index: 40;
  max-width: 1024px;
  margin: 0 auto;
  .columns {
    justify-content: space-between;
  }
  h3 {
    padding: 0.75rem;
  }
  .yoga-btn {
    width: 100%;
  }
  .basic-search {
    z-index: 45;
  }

  .close-text-search {
    font-size: 1.4rem;
    color: #ffffff;
    background-color: #fd7170;
    display: block;
    width: 3rem;
    text-align: center;
    height: 100%;
    .mdi {
      position: relative;
      top: 4px;
    }
  }
  .advanced-search {
    position: absolute;
    top: 105%;
    width: 100%;
    z-index: 10;
    // overflow: hidden;
    background-color: #fff;
    padding: 1rem;
    transition: all 1s ease;
    h4 {
      margin-bottom: 1rem;
    }
    .yoga-btn {
      max-width: 250px;
      margin: 0 auto;
    }
  }
  .advanced-search-open {
    position: static;
  }

  .slide-down-enter-active {
    transition: all 0.5s ease;
  }

  .slide-down-leave-active {
    transition: all 0.3s ease;
  }

  .slide-down-enter,
.slide-down-leave-to

/* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(-50%);
    opacity: 0;
    height: 0;
  }
}

.top-controls {
  transform: scale(0.9);
  .advanced-search-control {
    margin: 0 1rem 0 0;
    padding-left: 0;
  }
}

.advanced-search-control {
  display: inline-block;
  margin-left: 2rem;
  padding: 0.3rem 1rem;
  border: 1px solid transparent;
  color: #656b85;
  transition: all 0.2s ease;
  font-size: 1.05rem;
  &:hover {
    border-color: #656b85;
  }
}
.text-search-container {
  .yoga-btn {
    padding: 7px 10px;
    font-weight: bold;
    font-size: 1.2rem;
  }
}
.advanced-search-input {
  position: relative;
  input {
    width: 100%;
    font-size: 1.125rem;
    padding: 0.25rem;
    box-shadow: 7px 4px 10px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
  }
  .mdi {
    position: absolute;
    left: 1rem;
    top: 0;
    bottom: 0;
    display: inline-block;
    font-size: 2rem;
    line-height: 4rem;
    color: rgba(0, 0, 0, 0.53);
  }
}
</style>
